import { useCallback, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import {
  useContainersActions,
  useEmptyContainersStock,
  useEmptyContainerTypeById,
} from 'services/warehouse-containers/containers'
import { Loading } from 'components/ui/Loading/Loading'
import { Button } from 'components/ui/Button/Button'
import { Slider } from 'components/ui/Slider/Slider'
import { ContainerTypeOverview } from 'components/ContainerTypeOverview/ContainerTypeOverview'

export const ContainersOverview = () => {
  const navigate = useNavigate()
  const { containerTypeId } = useParams()
  const [amount, setAmount] = useState<number>(0)
  const [isActive, setIsActive] = useState<boolean>(false)
  const [containerIds, setContainerIds] = useState<string[]>([])

  const { args } = useEmptyContainersStock()
  const { isStockLoading, isEmptyContainersLoading, containerType, emptyContainers } =
    useEmptyContainerTypeById(containerTypeId)
  const { isLoading: isProcessing, transferContainers } = useContainersActions()

  const renderText = useCallback(
    () => (
      <span>
        Переместить <b>{amount}</b> контейнер(ов) <b>"{containerType?.name}"</b> на склад -{' '}
        <b>{args.to.name}</b>?
      </span>
    ),
    [amount]
  )

  const handleOnChange = (currAmount: number) => {
    setAmount(currAmount)
    setContainerIds(emptyContainers.slice(0, Math.min(currAmount, emptyContainers.length)))
  }

  const handleOnSubmit = () => setIsActive(true)

  const handleOnSliderSubmit = async () => {
    await transferContainers(args.to.id, containerIds)

    setIsActive(false)
    navigate(-1)
  }

  const handleOnSliderClose = () => {
    setIsActive(false)
  }

  if (isStockLoading || isProcessing || isEmptyContainersLoading) return <Loading />

  return (
    <>
      <ContainerTypeOverview
        containerType={containerType}
        value={amount}
        buttonText="Переместить"
        maxValue={emptyContainers.length}
        disabled={containerIds.length === 0}
        onChange={handleOnChange}
        onSubmit={handleOnSubmit}
      />
      <Slider isActive={isActive} height="180px" onClose={handleOnSliderClose}>
        <div className="container-overview__slider">
          <h2>Подтвердите действие</h2>
          <span>{renderText()}</span>
          <div className="container-overview__slider-controlls">
            <span style={{ marginRight: '0.5rem' }}>
              <Button title="Подтвердить" handleOnSubmit={handleOnSliderSubmit} />
            </span>
            <Button outline title="Отмена" handleOnSubmit={handleOnSliderClose} />
          </div>
        </div>
      </Slider>
    </>
  )
}
